"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THORCHAIN_AFFILIATE_BIPS = exports.THORCHAIN_AFFILIATE_NAME = exports.THORCHAIN_FIXED_PRECISION = exports.THOR_EVM_GAS_LIMIT = exports.THOR_MINIMUM_PADDING = exports.MAX_ALLOWANCE = exports.MAX_THORCHAIN_TRADE = void 0;
exports.MAX_THORCHAIN_TRADE = '100000000000000000000000000';
exports.MAX_ALLOWANCE = '100000000000000000000000000';
exports.THOR_MINIMUM_PADDING = 1.2;
exports.THOR_EVM_GAS_LIMIT = '100000'; // for sends of eth / erc20 into thorchain router
exports.THORCHAIN_FIXED_PRECISION = 8; // limit values are precision 8 regardless of the chain
exports.THORCHAIN_AFFILIATE_NAME = 'ss';
exports.THORCHAIN_AFFILIATE_BIPS = '0'; // affiliate fee in basis points (100 = 1%)
